export default __webpack_public_path__ + "static/img29h-c5edf282e680bfaa87c5ce182e4e8637.jpg";